<template>
  <div class="flex flex-row">
    <div :class="ballClasses">

    </div>
    <b class="ml-1 text-white">{{ deviceStore.ping }} MS</b>
  </div>
</template>

<script setup lang="ts">

const { $r3fetchdata } = useNuxtApp();
const intervalTime = 5000;
const ballClasses = ref<string>('ball ball--no-connection');
const deviceStore = useDeviceStore();



const pingTime = deviceStore.ping;
const sqlResponseTime = ref(0);
let pingInterval: NodeJS.Timeout;
onMounted(() => {
  pingInterval = setInterval(() => {
    doPing();
  }, intervalTime)

})

type pingResponse = {
  responseTime: {
    ping: number,
    sqlResponse: number
  }
}

function doPing() {
  const tempoInicial = performance.now();
  $r3fetchdata.get<pingResponse>('/api/utils/ping').then((res) => {
    const tempoFinal = performance.now();
    const ping = Math.round(((tempoFinal - tempoInicial) - res.responseTime.sqlResponse));
    deviceStore.setPing(ping);
    sqlResponseTime.value = ping;
    if (deviceStore.ping <= 5) {
      ballClasses.value = 'ball ball--green';
    } else if ((deviceStore.ping > 5) && (deviceStore.ping < 50)) {
      ballClasses.value = 'ball ball--yellow';
    } else if (deviceStore.ping >= 50) {
      ballClasses.value = 'ball ball--red';
    }

  }).catch(err => {

    ballClasses.value = 'ball ball--no-connection';

  })
}

onBeforeUnmount(() => {
  clearInterval(pingInterval);
})

onMounted(() => {
  doPing();
})

</script>


<style scoped lang="scss">
.ball {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.ball--green {
  background-color: #5BE523;
}

.ball--yellow {
  background-color: yellow;
}

.ball--red {
  background-color: red;
}

.ball--no-connection {
  background-color: black;
}
</style>